import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { useTranslation } from 'react-i18next';
import Placeholder from './Placeholder.jsx';
import styles from './BigStat.module.css';
import clsx from "clsx";

function BigStat({stat, secondStat, unit, icon, noData, twoLineStat = false}) {
  const {t} = useTranslation();
  return (
    <div className={clsx(styles.StatWrapper)}>
      <div className={clsx(styles.StatBox, twoLineStat && styles.TwoLineStatBox)}>
        {!noData && (
          <>
            <div className={styles.PrimaryStat}>
              <Placeholder ready={stat} xs={6} >
                <>
                  <span className={clsx(styles.Stat, twoLineStat && styles.TwoLineStat)}>
                        {icon && <FontAwesomeIcon icon={icon} />}
                        {stat}
                  </span>
                  {unit && <span className={styles.Unit}>&nbsp;{unit}</span>}
                </>
              </Placeholder>
            </div>
            <div className={styles.SecondStat}>
              {secondStat && (
                <Placeholder ready={stat && secondStat} xs={11}>
                  {secondStat}
                </Placeholder>
              )}
            </div>
          </>
        )}
    </div>

</div>
  );
}

export default BigStat
